import config from './config';

const currentYear = new Date().getFullYear();

const footer = config({
  /** Defaults for all sites and locales. */
  default: {
    /** Default settings for all languages. */
    default: {
      /** Shows an additional promo link on the footer UI. */
      showBottomPromoLink: false,

      /** Shows the country and language selector in the footer UI. */
      showCountryAndLanguageSelector: true,

      /**
       * The main footer menu, displays headers which contain
       * groups of links which contain an id, a label, an href, and an optional newTab field.
       */
      footerMenu: [
        {
          id: 'help',
          label: 'Help',
          links: [
            {
              id: 'help-center',
              label: 'Customer Service',
              href: '/help-center',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'accessibility',
              label: 'Website Accessibility',
              href: '/accessibility',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'warranty',
              label: 'Warranty',
              href: '/warranty',
              newTab: false,
              needsLogin: false,
              prefetch: true
            }
          ]
        },
        {
          id: 'orders',
          label: 'Orders',
          links: [
            {
              id: 'shipping-information',
              label: 'Shipping Information',
              href: '/shipping-information',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'order-status',
              label: 'Order Status',
              href: '/orders',
              newTab: false,
              needsLogin: true,
              prefetch: true
            },
            {
              id: 'returns',
              label: 'Returns & Exchanges',
              href: '/returns',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'gift-cards',
              label: 'Gift Cards',
              href: '/giftcards',
              newTab: false,
              needsLogin: false,
              prefetch: true
            }
          ]
        },
        {
          id: 'company',
          label: 'Company',
          links: [
            {
              id: 'brand',
              label: 'About Us',
              href: '/about',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'blog',
              label: 'Blog',
              href: '/blog',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'corporate-responsibility',
              label: 'Corporate Responsibility',
              href: '/corporate-responsibility',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'jobs',
              label: 'Jobs',
              href: 'https://www.deckers.com/careers',
              newTab: true,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'stores',
              label: 'Store Location',
              href: '/storelocator',
              newTab: false,
              needsLogin: false,
              prefetch: true
            }
          ]
        }
      ],
      /**
       * The footer submenu sits below the main footer menu. Each entry should be
       * componsed of an id, a label, and an href.
       */
      footerSubMenu: [
        {
          id: 'international',
          label: 'Visit our international sites',
          href: '/choose-country',
          newTab: false,
          needsLogin: false,
          prefetch: true
        },
        {
          id: 'deckers',
          label: `© ${currentYear} Deckers Brands`,
          href: 'https://www.deckers.com',
          newTab: true,
          needsLogin: false,
          prefetch: true
        },
        {
          id: 'privacy-policy',
          label: 'Privacy Policy',
          href: '/privacy-policy',
          newTab: false,
          needsLogin: false,
          prefetch: true
        },
        {
          id: 'cookie-policy',
          label: 'Cookie Policy',
          href: '/cookies',
          newTab: false,
          needsLogin: false,
          prefetch: true
        },
        {
          id: 'terms-and-conditions',
          label: 'Terms and Conditions',
          href: '/terms-and-conditions',
          newTab: false,
          needsLogin: false,
          prefetch: true
        },
        {
          id: 'accessibility',
          label: 'Website Accessibility',
          href: '/accessibility',
          newTab: false,
          needsLogin: false,
          prefetch: true
        },
        {
          id: 'transparency',
          label: 'CA Transparency Act',
          href: '/Public-Statement-SB-657.pdf',
          newTab: true,
          needsLogin: false,
          // Since it is a static asset, with the way things work right now it will always error on prefetch.
          prefetch: false
        },
        {
          id: 'cookies-preference',
          label: 'Cookie Preferences',
          href: '#',
          newTab: false,
          needsLogin: false,
          prefetch: true
        }
      ],
      /**
       * The link to accessibility page when click on accessibility icon.
       */
      accessibilityIcon: {
        href: '',
        newTab: false,
        prefetch: true,
        src: '/images/Deckers_eA_Icon_transparent.png'
      },

      /** Configuration for the footer brand logo displayed in the "Stay Connected" section. */
      footerLogo: {
        show: false,
        src: '',
        alt: ''
      }
    }
  },
  'AHNU-US': {
    default: {
      /** Ahnu Footer Structure. */
      /**
       * The main footer menu, displays headers which contain
       * groups of links which contain an id, a label, an href, and an optional newTab field.
       */
      footerMenu: [
        {
          id: 'help',
          label: 'Help',
          links: [
            {
              id: 'help-center',
              label: 'Customer Service',
              href: '/help-center',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'accessibility',
              label: 'Website Accessibility',
              href: '/accessibility',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'warranty',
              label: 'Warranty',
              href: '/warranty',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'ahnu-affiliate-program',
              label: 'AHNU Affiliate Program',
              href: '/ahnu-affiliate-program',
              newTab: false,
              needsLogin: false,
              prefetch: true
            }
          ]
        },
        {
          id: 'orders',
          label: 'Orders',
          links: [
            {
              id: 'shipping-information',
              label: 'Shipping Information',
              href: '/shipping-information',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'order-status',
              label: 'Order Status',
              href: '/orders',
              newTab: false,
              needsLogin: true,
              prefetch: true
            },
            {
              id: 'returns',
              label: 'Returns & Exchanges',
              href: '/returns',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'gift-cards',
              label: 'Gift Cards',
              href: '/giftcards',
              newTab: false,
              needsLogin: false,
              prefetch: true
            }
          ]
        },
        {
          id: 'company',
          label: 'Company',
          links: [
            {
              id: 'brand',
              label: 'About Us',
              href: '/about',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'stores',
              label: 'Stores',
              href: '/storelocator',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'corporate-responsibility',
              label: 'Corporate Responsibility',
              href: 'https://www.deckers.com/responsibility',
              newTab: true,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'jobs',
              label: 'Jobs',
              href: 'https://www.deckers.com/careers',
              newTab: true,
              needsLogin: false,
              prefetch: true
            }
          ]
        }
      ],
      /**
       * The footer submenu sits below the main footer menu. Each entry should be
       * componsed of an id, a label, and an href. This is an empty array in order
       * to "hide" all these items from the UI.
       */
      footerSubMenu: []
    }
  },
  'TEVA-US': {
    default: {
      /** Teva Footer Structure. */
      /**
       * The main footer menu, displays headers which contain
       * groups of links which contain an id, a label, an href, and an optional newTab field.
       */
      footerMenu: [
        {
          id: 'aboutus',
          label: 'ABOUT US',
          links: [
            {
              id: 'our-story',
              label: 'Our Story',
              href: '/about',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'our-commitment',
              label: 'Our Commitment',
              href: '/our-commitment',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'careers',
              label: 'Careers',
              href: 'https://www.deckers.com/careers',
              newTab: true,
              needsLogin: false,
              prefetch: true
            }
          ]
        },
        {
          id: 'quicklinks',
          label: 'QUICK LINKS',
          links: [
            {
              id: 'sizing',
              label: 'Sizing Information',
              href: '/sizing-information',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'stores',
              label: 'Stores',
              href: '/storelocator',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'giftcards',
              label: 'Gift Cards',
              href: '/giftcards',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'pro-deals',
              label: 'Teva Pro Deals',
              href: '/IPA-Pro',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'affiliate-program',
              label: 'Teva Affiliate Program',
              href: '/teva-affiliate-program',
              newTab: false,
              needsLogin: false,
              prefetch: true
            }
          ]
        },
        {
          id: 'help',
          label: 'HELP',
          links: [
            {
              id: 'returns',
              label: 'Returns & Exchanges',
              href: '/returns',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'customer-service',
              label: 'Customer Service',
              href: '/help-center',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'faqs',
              label: 'FAQs',
              href: '/help-center',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'order-status',
              label: 'Order Status',
              href: '/login',
              newTab: false,
              needsLogin: true,
              prefetch: true
            },
            {
              id: 'shipping-information',
              label: 'Shipping Information',
              href: '/help-center?a=Shipping-Information---id--xapezn7-SAey1dLfTe8WlA',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'warranty',
              label: 'Warranties',
              href: '/help-center?a=Warranty-Information---id--zN9it5YCTherZT1JFastqg',
              newTab: false,
              needsLogin: false,
              prefetch: true
            }
          ]
        }
      ],
      /**
       * The footer submenu sits below the main footer menu. Each entry should
       * be composed of an id, a label, and an href.
       */
      footerSubMenu: [
        {
          id: 'international',
          label: 'Visit our international sites',
          href: '/choose-country',
          newTab: false,
          needsLogin: false,
          prefetch: true
        },
        {
          id: 'deckers',
          label: `© ${currentYear} Deckers Brands`,
          href: 'https://www.deckers.com',
          newTab: true,
          needsLogin: false,
          prefetch: true
        },
        {
          id: 'privacy-policy',
          label: 'Privacy Policy',
          href: '/privacy-policy',
          newTab: false,
          needsLogin: false,
          prefetch: true
        },
        {
          id: 'cookies-policy',
          label: 'Cookies Policy',
          href: '/cookies',
          newTab: false,
          needsLogin: false,
          prefetch: true
        },
        {
          id: 'cookies-preference',
          label: 'Cookie Preferences',
          href: '#',
          newTab: false,
          needsLogin: false,
          prefetch: true
        },
        {
          id: 'terms-and-conditions',
          label: 'Terms and Conditions',
          href: '/terms-and-conditions',
          newTab: false,
          needsLogin: false,
          prefetch: true
        },
        {
          id: 'accessibility',
          label: 'Website Accessibility',
          href: '/accessibility',
          newTab: false,
          needsLogin: false,
          prefetch: true
        },
        {
          id: 'transparency',
          label: 'CA Transparency Act',
          href: '/Public-Statement-SB-657.pdf',
          newTab: true,
          needsLogin: false,
          // Since it is a static asset, with the way things work right now it will always error on prefetch.
          prefetch: false
        },
        {
          id: 'do-not-sell-my-personal-information',
          label: 'Do Not Sell My Personal Information',
          href: '/privacy-policy#PP17-5',
          newTab: true,
          needsLogin: false,
          prefetch: true
        }
      ],
      accessibilityIcon: {
        href: 'https://www.levelaccess.com/a/teva/',
        newTab: true,
        prefetch: true
      }
    }
  },
  'HOKA-US': {
    default: {
      /** Hoka Footer Structure. */

      showBottomPromoLink: false,

      footerLogo: {
        show: true,
        src: '/images/hoka-footer-logo.png',
        alt: 'HOKA ONE ONE - Time to Fly'
      },

      /**
       * The main footer menu, displays headers which contain
       * groups of links which contain an id, a label, an href, and an optional newTab field.
       */
      footerMenu: [
        {
          id: 'company',
          label: 'Company',
          links: [
            {
              id: 'our-story',
              label: 'Our Story',
              href: '/about',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'our-impact',
              label: 'Our Impact',
              href: '/hoka-impact',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'careers',
              label: 'Careers',
              href: '/careers',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'affiliate-program',
              label: 'Affiliate Program',
              href: '/hoka-affiliate-program',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'product-testing-program',
              label: 'Product Testing Program',
              href: '/product-testing-program',
              newTab: false,
              needsLogin: false,
              prefetch: true
            }
          ]
        },
        {
          id: 'customer-care',
          label: 'Customer Care',
          links: [
            {
              id: 'help-center',
              label: 'Help Center',
              href: '/help-center',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'guarantee',
              label: 'Fly for 30 Guarantee',
              href: '/guarantee',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'returns-exchanges',
              label: 'Returns & Exchanges',
              href: '/returns',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'orders',
              label: 'Order Status',
              href: '/orders',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'warranty',
              label: 'Warranty',
              href: '/warranty',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'corporate-sales',
              label: 'Corporate Sales',
              href: '/corporate-sales',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'counterfeit',
              label: 'Counterfeit Websites & Phishing',
              href: '/hoka-product-authenticity',
              newTab: false,
              needsLogin: false,
              prefetch: true
            }
          ]
        },
        {
          id: 'resources',
          label: 'Resources',
          links: [
            {
              id: 'sizing-information',
              label: 'Sizing Guide',
              href: '/sizing-information',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'truefit',
              label: 'True Fit',
              href: '/truefit-size-guides',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'care-and-clothing',
              label: 'Care & Clothing',
              href: '/care-and-cleaning',
              newTab: false,
              needsLogin: false,
              prefetch: true
            }
          ]
        },
        {
          id: 'shop',
          label: 'Shop',
          links: [
            {
              id: 'shoe-finder',
              label: 'Shoe Finder',
              href: '/hoka-shoe-finder',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'sale',
              label: 'SALE',
              href: '/sale',
              newTab: false,
              needsLogin: false,
              prefetch: true
            },
            {
              id: 'stores',
              label: 'Find a store',
              href: '/stores',
              newTab: false,
              needsLogin: false,
              prefetch: true
            }
          ]
        }
      ],

      accessibilityIcon: {
        href: 'https://www.levelaccess.com/a/hoka/',
        newTab: true,
        prefetch: true,
        src: '/images/Deckers_eA_Icon_dark.svg'
      },

      footerSubMenu: [
        {
          id: 'international',
          label: 'Visit our international sites',
          href: '/choose-country',
          newTab: false,
          needsLogin: false,
          prefetch: true
        },
        {
          id: 'deckers',
          label: `© ${currentYear} Deckers Brands`,
          href: 'https://www.deckers.com',
          newTab: true,
          needsLogin: false,
          prefetch: true
        },
        {
          id: 'privacy-policy',
          label: 'Privacy Policy',
          href: '/privacy-policy',
          newTab: false,
          needsLogin: false,
          prefetch: true
        },
        {
          id: 'cookie-policy',
          label: 'Cookies Policy',
          href: '/cookies',
          newTab: false,
          needsLogin: false,
          prefetch: true
        },
        {
          id: 'cookies-preference',
          label: 'Cookie Preference',
          href: '#',
          newTab: false,
          needsLogin: false,
          prefetch: true
        },
        {
          id: 'terms-and-conditions',
          label: 'Terms & Conditions',
          href: '/terms-and-conditions',
          newTab: false,
          needsLogin: false,
          prefetch: true
        },
        {
          id: 'accessibility',
          label: 'Website Accessibility',
          href: '/accessibility',
          newTab: false,
          needsLogin: false,
          prefetch: true
        },
        {
          id: 'transparency',
          label: 'CA Transparency Act',
          href: '/FY2024_statement_against_modern_slavery.pdf',
          newTab: true,
          needsLogin: false,
          prefetch: false
        },
        {
          id: 'do-not-sell',
          label: 'Do Not Sell My Personal Information',
          href: '/do-not-sell',
          newTab: false,
          needsLogin: false,
          prefetch: true
        }
      ]
    }
  }
});

export default footer;
